export default __webpack_public_path__ + "static/share-574232c1c48c85aa822f14a05882180f.jpg";